module.exports = __webpack_public_path__ + "static/img/case-left.c2a7ffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/smart/case-left.png
// module id = KuAL
// module chunks = 0 2